<template>
  <div>
    <div class="pa-0 ma-0" style="background-color: white;">
      <NavBar styleType="finance"></NavBar>
      <div ref="videoContainerEmpty" id="videoContainerEmpty" class="pa-0 ma-0" :style="{ height: videoHeight + 'px' }">
        <div id="videoContent" class="pa-0 ma-0" :style="{ height: videoHeight + 'px' }">
          <div id="bkgrdVideoOverlay" :style="{ height: videoHeight + 'px' }"></div>
        </div>
      </div>

      <div class="body-overall page-top page-bottom fonts" style="color:black!important;">
            <v-row class="textPanel pb-8">
                <div class="container">
                  <v-divider class="divider ml-9 mr-9 hidden-xs" style="color:black!important;"></v-divider>
                  <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up" style="color:black!important;"></v-divider>
                  <v-row justify="start" class="pl-12 pr-12 hidden-xs">
                    <v-col cols="6" class="pa-0 ma-0">                  
                      <h1 class="font2-heada" style="color:black!important;">GENERATIONAL WEALTH MANAGEMENT</h1>
                    </v-col>
                    <v-col cols="6" justify="start" class="pa-0 ma-0">  
                      <v-row class="pl-6 pt-5">
                        <span class="mt-0 pb-0 mb-0 fonts-desc" style="color:black!important;">
                        Our wealth management services are designed to help families preserve and grow their assets across generations.
                        Access to this area is restricted to clients only. Please contact us for more information.
                      </span>
                      </v-row>                
                      <v-btn text plain :ripple="false" elevation="0" style="color:black!important;" class="text-none nomenu-btn-page"  @click="handleClickVideo('Contact')">
                        Contact
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-up pt-0 mt-0">
                        <h1 class="font2-heada" style="color:black!important;">GENERATIONAL WEALTH MANAGEMENT</h1>
                  </v-row>
                  <v-row justify="start" class="pl-12 pr-12 pt-4 pb-4 hidden-sm-and-up pt-0 mt-0">
                        <span class="mt-0 pb-0 mb-0 pl-0 fonts-desc" style="color:black!important;">
                        Our wealth management services are designed to help families preserve and grow their assets across generations.
                        Access to this area is restricted to clients only. Please contact us for more information.
                                              </span>
                      </v-row>  
                  <v-row justify="start" class="pl-9 pr-9 hidden-sm-and-up pt-0 mt-0">
                      <v-btn text plain :ripple="false" elevation="0" style="color:black!important;" class="text-none nomenu-btn-page"  @click="handleClickVideo('Contact')">
                        Contact
                      </v-btn>
                  </v-row>
                </div>
            </v-row>
            <v-row class="textPanel page-top pb-8">
                <div class="full-container">
                  <v-row justify="start" class="pl-12 pr-12 hidden-sm-and-down">
                    <v-col cols="12" class="pa-0 ma-0 pr-4">                  
                      <h1 class="fonts-desc" style="color:black!important;">
                        Monitoring NAV in a hedge fund requires regular valuation and reconciliation of holdings, accounting for subscriptions/redemptions, fees and accruals to ensure an accurate per‑share NAV and liquidity picture. 
                        Portfolio analysis focuses on performance attribution, factor exposures, concentration and correlation checks, plus stress and scenario testing to identify return drivers and vulnerabilities. 
                        A concise portfolio overview summarizes current allocations, top positions, liquidity profiles and key risk metrics (VaR, drawdown, beta, others) with benchmark comparisons to guide risk management and rebalancing.
                        <br/><br/>Tailored to the unique needs of hedge fund managers, our NAV monitoring and portfolio analysis services provide the insights necessary for effective fund management and informed decision-making.

                      </h1>
                    </v-col>
                  </v-row>

                  <v-row justify="start" class="pl-12 pr-12 hidden-md-and-up pt-8 mt-0">
                        <h1 class="fonts-desc" style="color:black!important;">
                        Monitoring NAV in a hedge fund requires regular valuation and reconciliation of holdings, accounting for subscriptions/redemptions, fees and accruals to ensure an accurate per‑share NAV and liquidity picture. 
                        Portfolio analysis focuses on performance attribution, factor exposures, concentration and correlation checks, plus stress and scenario testing to identify return drivers and vulnerabilities. 
                        A concise portfolio overview summarizes current allocations, top positions, liquidity profiles and key risk metrics (VaR, drawdown, beta, others) with benchmark comparisons to guide risk management and rebalancing.
                        <br/><br/>Tailored to the unique needs of hedge fund managers, our NAV monitoring and portfolio analysis services provide the insights necessary for effective fund management and informed decision-making.

                        </h1>
                  </v-row>
                </div>
            </v-row>
      </div>
          <v-row class="textPanel page-top pb-0 pt-4">
                <div class="full-container">
                  <v-img  style="opacity: 0.9" :src="require('@/assets/images/about_mc1.webp')"></v-img>
                </div>
          </v-row>
          <div class="body-overall fonts">
            <v-row class="textPanel pb-0">
              <v-divider class="divider ml-9 mr-9 hidden-xs mt-14" style="color: black!important;"></v-divider>
              <v-divider class="dividerxs ml-9 mr-9 hidden-sm-and-up mt-14" style="color: black!important;"></v-divider>
            </v-row>
          </div>
      <div class="body-overall fonts">
          <Footer typed="finance"></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from './NavBar'
import Footer from './Footer'

export default {
  name: 'FortyTwo',
  props: ['drawerham'],

  components: {
    NavBar,
    Footer
  },
  data: () => ({
    videoHeight: 1000, // Initial height of the video
    pausedVideo: true
  }),
  mounted() {  
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  destroyed() {
  },
  computed: {

  },  
  created() {

  }, 
  methods: {
    handleScroll() {
      if (!this.drawerham){
        // Get the current scroll position
        const scrollPosition = Math.round(window.scrollY || window.pageYOffset);
        // Calculate the new height for the video
        const newVideoHeight = Math.round(Math.max(500, 1000 - scrollPosition));
        // Update the video height
        this.videoHeight = newVideoHeight;
      }
    },
    handleClickVideo(link){
      if (link === 'Log'){
        window.open('https://selene.42monks.com/','_blank');
      } else if (link === 'Office'){
        window.open('https://office.42monks.com/','_blank');
      } else {
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>

@use './css/styles.scss';

:deep(.v-btn:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item:hover)>.v-list-item__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item__append){
  display: inline-block;
}

.full-container {
  background-color: white !important;
    width: 100%!important;
    max-width: 100%!important;
    margin-right: auto!important;
    margin-left: auto!important;

  @media (min-width: 600px) {
    width: 100%!important;
  }

  @media (min-width: 1280px) {
    width: 1625px!important;
  }
}

#videoContainer {
  position: relative;
  box-sizing: border-box;
  max-height: 100px;
  transition: height 0.10s linear;
}

#videoContainerEmpty {
  position: relative;
  box-sizing: border-box;
  max-height: 100px;
  transition: height 0.10s linear;
}

#videoContent {
  position: sticky;
  top: 0;
  max-height: 100px;
  transition: height 0.10s linear;
}

#bkgrdVideoOverlay {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  max-height: 100px;
  object-fit: cover; 
  background-color: #00000000; 
  z-index: 5;
  transition: height 0.10s linear;
}
#bkgrdVideoFunc {
  position: relative;
  width: 100%;
  object-fit: contain; 
  background-color: white; 
  z-index: 6;
  transition: height 0.10s linear;
}

#bkgrdVideo2 {
  width: 100%;
  object-fit: contain; 
  z-index:1;
  transition: height 0.10s linear;
}

.body-overall {
  background-color: white !important;
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  z-index: 3;
}


.nomenu-btn-page {
  color: white;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  box-shadow: none !important;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-page.active,
.nomenu-btn-page:hover {
  color: black;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 30px;
  width: 92%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: black; /* Color of the underline */
  opacity: 1; /* Initially hide the underline */
}

.nomenu-btn-page.active::before,
.nomenu-btn-page:hover::before {
  opacity: 0.3; /* Show the underline when hovering */
}




</style>

